import { useContext, useState } from 'react';
import UserMenu from '../components/security/UserMenu';
import { RoutesFlags } from '../../constants';
import { AppContext } from '../context';
import { UseGetLanguage } from '../hooks';
import './App.css';

/**
 *
 * @returns Componente el cual es el encabezado de la aplicación contiene el logo, opciones de lenguaje, ayudas y menu del usuario
 */
export default function Header() {
    const {
        langResources,
        isSkinSmart,
        isCollapseTree,
        setIsCollapseTree,
        userInfo,
        activeSkinConfig
    } = useContext(AppContext);

    const [isFullScreen, setIsFullScreen] = useState(false);

    const { handlerChangeLenguage, selectedFlag } = UseGetLanguage();

    /**
     * Funcion para manejar los eventos de la barra lateral si se puede abrir o no
     */
    const toogleMenuBtn = () => {
        var scrollbar = document.getElementById('scrollbar');

        setIsCollapseTree(!isCollapseTree);
        document.querySelector('.hamburger-icon')?.classList.toggle('open');
        scrollbar?.classList.toggle('scrollbar');
    };

    /**
     * Funcion para convertir a pantalla completa o normal
     */
    const changeMode = () => {
        if (isFullScreen) {
            document.exitFullscreen();
        } else {
            document.documentElement.requestFullscreen();
        }
        setIsFullScreen(!isFullScreen);
    };

    return (
        <>
            <header id='page-topbar' style={{ height: 60, zIndex: 88888 }}>
                <div className='layout-width h-100'>
                    {!isSkinSmart && (
                        <ul className='background'>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    )}
                    <div className='navbar-header h-100'>
                        <div className='d-flex'>
                            <div className='navbar-brand-box horizontal-logo h-100'>
                                <a href='/' className='logo logo-light '>
                                    <span className='logo-sm '>
                                        <img
                                            style={{
                                                height: isSkinSmart
                                                    ? '16px'
                                                    : '30px',
                                            }}
                                            src={`/assets/images/${
                                                isSkinSmart
                                                    ? 'logo-sm'
                                                    : 'siesa-light'
                                            }.png`}
                                            alt=''
                                            height='22'
                                        />
                                    </span>
                                    <span className='logo-lg'>
                                        <img
                                            style={{
                                                height: activeSkinConfig.logoNavBarHeight,
                                            }}
                                            src={`/assets/images/${activeSkinConfig.logoFileName}.png`}
                                            alt=''
                                        />
                                    </span>
                                </a>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type='button'
                                className='btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger text-black'
                                id='topnav-hamburger-icon'
                            >
                                <span className='hamburger-icon text-black'>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                        <div className='d-flex align-items-center h-100'>
                            <div className='d-none d-lg-block'>
                                <div className='scollbar'>
                                    <div className='container-fluid px-1'>
                                        <ul className='navbar-nav' id='navbar-nav'>
                                            <li className='nav-item'>
                                                <a
                                                    className='btn btn-icon btn-topbar btn-ghost-secondary rounded-circle'
                                                    data-bs-toggle='collapse'
                                                    href='#'
                                                >
                                                    <span
                                                        className=''
                                                        style={{
                                                            marginRight: 7,
                                                            width: 28,
                                                            height: 28,
                                                            border: 'none',
                                                            borderRadius: '50%',
                                                        }}
                                                    >
                                                        <img
                                                            src={selectedFlag}
                                                            className='h-100 w-100 rounded-pill'
                                                            alt=''
                                                        />
                                                    </span>
                                                </a>

                                                <div
                                                    id='sidebarApps'
                                                    className='menu-dropdown collapse'
                                                    style={{
                                                        right: 0,
                                                    }}
                                                >
                                                    <ul className='nav nav-sm flex-column test gap-2 p-2'>
                                                        <li
                                                            style={{
                                                                cursor: 'pointer',
                                                            }}
                                                            className='nav-item px-2 d-flex justify-content-start aling-items-center btn-withe'
                                                            onClick={(e) =>
                                                                handlerChangeLenguage(
                                                                    'en-US'
                                                                )
                                                            }
                                                        >
                                                            <span
                                                                className=''
                                                                style={{
                                                                    marginRight: 7,
                                                                    width: 20,
                                                                    height: 20,
                                                                    border: 'none',
                                                                    borderRadius:
                                                                        '50%',
                                                                }}
                                                            >
                                                                <img
                                                                    src={
                                                                        RoutesFlags[
                                                                            'en-US'
                                                                        ]
                                                                    }
                                                                    className='h-100 w-100  rounded-pill'
                                                                    alt=''
                                                                />
                                                            </span>
                                                            <span className='fs-9'>
                                                                {
                                                                    langResources[
                                                                        'english.label'
                                                                    ]
                                                                }
                                                            </span>
                                                        </li>

                                                        <li
                                                            style={{
                                                                cursor: 'pointer',
                                                            }}
                                                            className=' nav-item px-2 d-flex justify-content-start aling-items-center btn-withe'
                                                            onClick={(e) =>
                                                                handlerChangeLenguage(
                                                                    'es-CO'
                                                                )
                                                            }
                                                        >
                                                            <span
                                                                className=' '
                                                                style={{
                                                                    marginRight: 7,
                                                                    width: 20,
                                                                    height: 20,
                                                                    border: 'none',
                                                                    borderRadius:
                                                                        '50%',
                                                                }}
                                                            >
                                                                <img
                                                                    src={
                                                                        RoutesFlags[
                                                                            'es-CO'
                                                                        ]
                                                                    }
                                                                    className='h-100 w-100  rounded-pill'
                                                                    alt=''
                                                                />
                                                            </span>
                                                            <span className='fs-9'>
                                                                {
                                                                    langResources[
                                                                        'spanish.label'
                                                                    ]
                                                                }
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {userInfo.role.name === 'ADMINISTRADOR' && (
                                <div className='d-none d-lg-block'>
                                    <div className='scollbar '>
                                        <div className='container-fluid px-1'>
                                            <ul
                                                className='navbar-nav'
                                                id='navbar-nav'
                                            >
                                                <li className='nav-item'>
                                                    <a
                                                        className='btn btn-icon btn-topbar btn-ghost-secondary rounded-circle'
                                                        data-bs-toggle='collapse'
                                                        href='#'
                                                    >
                                                        <i
                                                            className={`ri-information-line fs-2 ${
                                                                !isSkinSmart &&
                                                                'text-light'
                                                            }`}
                                                        ></i>
                                                    </a>

                                                    <div
                                                        id='sidebarApps'
                                                        className='menu-dropdown collapse'
                                                        style={{
                                                            right: 0,
                                                        }}
                                                    >
                                                        <ul className='nav nav-sm flex-column test'>
                                                            <li className='nav-item px-3'>
                                                                <div className='nav nav-sm flex-column  justify-content-center'>
                                                                    <div className='d-flex gap-1 flex-column'>
                                                                        <li className='d-flex aling-items-center'>
                                                                            <button
                                                                                className='badge rounded-pill bg-info'
                                                                                style={{
                                                                                    marginRight: 7,
                                                                                    width: 25,
                                                                                    height: 20,
                                                                                    border: 'none',
                                                                                }}
                                                                            >
                                                                                2
                                                                            </button>
                                                                            <span className='fs-9'>
                                                                                {
                                                                                    langResources[
                                                                                        'news.center.modal'
                                                                                    ][
                                                                                        'news'
                                                                                    ]
                                                                                }
                                                                            </span>
                                                                        </li>

                                                                        <li className='d-flex aling-items-center'>
                                                                            <button
                                                                                className='badge rounded-pill bg-danger'
                                                                                style={{
                                                                                    marginRight: 7,
                                                                                    width: 25,
                                                                                    height: 20,
                                                                                    border: 'none',
                                                                                }}
                                                                            >
                                                                                1
                                                                            </button>
                                                                            <span className='fs-9'>
                                                                                {
                                                                                    langResources[
                                                                                        'news.center.modal'
                                                                                    ][
                                                                                        'inconsistencies'
                                                                                    ]
                                                                                }
                                                                            </span>
                                                                        </li>

                                                                        <li className='d-flex aling-items-center'>
                                                                            <button
                                                                                className='rounded-pill'
                                                                                style={{
                                                                                    marginRight: 7,
                                                                                    background:
                                                                                        '#aace56',
                                                                                    borderColor:
                                                                                        '#aace56',
                                                                                    width: 25,
                                                                                    height: 20,
                                                                                    border: 'none',
                                                                                }}
                                                                            ></button>
                                                                            <span className='fs-9'>
                                                                                {
                                                                                    langResources[
                                                                                        'news.center.modal'
                                                                                    ][
                                                                                        'workshift'
                                                                                    ]
                                                                                }
                                                                            </span>
                                                                        </li>

                                                                        <li className='d-flex aling-items-center'>
                                                                            <button
                                                                                className='rounded-pill'
                                                                                style={{
                                                                                    marginRight: 7,
                                                                                    background:
                                                                                        '#aace56',
                                                                                    border: '0.5px solid #FF3A1A',
                                                                                    width: 25,
                                                                                    height: 20,
                                                                                }}
                                                                            ></button>
                                                                            <span className='fs-9'>
                                                                                {
                                                                                    langResources[
                                                                                        'news.center.modal'
                                                                                    ][
                                                                                        'exceptional.workshift'
                                                                                    ]
                                                                                }
                                                                            </span>
                                                                        </li>

                                                                        <li className='d-flex aling-items-center'>
                                                                            <button
                                                                                className='rounded-pill bgInterruption'
                                                                                style={{
                                                                                    marginRight: 7,
                                                                                    width: 25,
                                                                                    height: 20,
                                                                                    border: 'none',
                                                                                }}
                                                                            ></button>
                                                                            <span className='fs-9'>
                                                                                {
                                                                                    langResources[
                                                                                        'news.center.modal'
                                                                                    ][
                                                                                        'interruption.label'
                                                                                    ]
                                                                                }
                                                                            </span>
                                                                        </li>

                                                                        <li className='d-flex aling-items-center'>
                                                                            <button
                                                                                className='rounded-pill'
                                                                                style={{
                                                                                    marginRight: 7,
                                                                                    background:
                                                                                        '#587B1A',
                                                                                    width: 25,
                                                                                    height: 20,
                                                                                    border: 'none',
                                                                                }}
                                                                            ></button>
                                                                            <span className='fs-9'>
                                                                                {
                                                                                    langResources[
                                                                                        'news.center.modal'
                                                                                    ][
                                                                                        'additional.time'
                                                                                    ]
                                                                                }
                                                                            </span>
                                                                        </li>

                                                                        <li className='d-flex aling-items-center'>
                                                                            <button
                                                                                className='rounded-pill'
                                                                                style={{
                                                                                    marginRight: 7,
                                                                                    background:
                                                                                        '#D2DA9F',
                                                                                    width: 25,
                                                                                    height: 20,
                                                                                    border: 'none',
                                                                                }}
                                                                            ></button>
                                                                            <span className='fs-9'>
                                                                                {
                                                                                    langResources[
                                                                                        'news.center.modal'
                                                                                    ][
                                                                                        'float.workshift'
                                                                                    ]
                                                                                }
                                                                            </span>
                                                                        </li>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div
                                className=' d-none d-sm-flex '
                                title={langResources['full.screen.label']}
                            >
                                <button
                                    type='button'
                                    className='btn btn-icon btn-topbar btn-ghost-secondary rounded-circle'
                                    data-toggle='fullscreen'
                                    onClick={changeMode}
                                >
                                    {!isFullScreen ? (
                                        <i
                                            className={`ri-aspect-ratio-line fs-2 ${
                                                !isSkinSmart && 'text-light'
                                            }`}
                                        ></i>
                                    ) : (
                                        <i
                                            className={`ri-fullscreen-exit-fill fs-2 ${
                                                !isSkinSmart && 'text-light'
                                            }`}
                                        ></i>
                                    )}
                                </button>
                            </div>

                            <UserMenu></UserMenu>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}
